export default __webpack_public_path__ + "static/media/video-3.10647337.mp4";